import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const NAMES = ['Mariana de Bogotá', 'Valentina de Lima', 'Sofía de Santiago', 'Camila de Buenos Aires', 'Isabella de Medellín', 'Lucía de Montevideo', 'Gabriela de Quito', 'Elena de Ciudad de México', 'Martina de Córdoba'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [name, setName] = useState(NAMES[0]);
  useEffect(() => {
    // Initial delay: 8 seconds
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 8000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    // Hide after 6 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      // Schedule next appearance (random 25-40s)
      const nextDelay = Math.floor(Math.random() * (40000 - 25000 + 1) + 25000);
      setTimeout(() => {
        setName(NAMES[Math.floor(Math.random() * NAMES.length)]);
        setIsVisible(true);
      }, nextDelay);
    }, 6000);
    return () => clearTimeout(hideTimer);
  }, [isVisible]);
  return <AnimatePresence data-id="element-131">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 20,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 z-50 max-w-xs w-full bg-white rounded-xl shadow-lg p-4 flex items-start gap-3 border border-[#F5F1EA]" data-id="element-132">
          <div className="bg-[#5C6B60]/10 p-2 rounded-full flex-shrink-0" data-id="element-133">
            <CheckCircle2 className="w-5 h-5 text-[#5C6B60]" data-id="element-134" />
          </div>
          <div data-id="element-135">
            <p className="text-sm text-gray-800 font-medium leading-snug" data-id="element-136">
              <span className="font-bold text-[#5C6B60]" data-id="element-137">{name}</span> acaba de
              acceder al Programa de Activación Lectora.
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-138">Hace unos instantes</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}